import React, { useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Users, Mail, Tag, Image, FileText, Settings, LogOut, Gem } from "lucide-react";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";

const central = [
  ["/admin", "Dashboard", LayoutDashboard, true],
  ["/admin/orders", "Orders", ShoppingCart],
  ["/admin/customers", "Customers", Users],
  ["/admin/marketing", "Newsletter & Campaigns", Mail],
  ["/admin/discounts", "Discount Codes", Tag],
  ["/admin/ring-requests", "Custom Ring Requests", Gem],
  ["/admin/settings", "Settings", Settings],
];
const storefront = [
  ["/admin/products", "Products", Package],
  ["/admin/content", "Content & Pages", FileText],
  ["/admin/images", "Site Images", Image],
];

export default function AdminLayout() {
  const { user, setUser } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === false) navigate("/login");
    else if (user && user.role !== "admin") navigate("/");
  }, [user]);

  const logout = async () => { await api.post("/auth/logout"); setUser(false); navigate("/login"); };

  if (!user || user.role !== "admin") return <div className="h-screen flex items-center justify-center font-sans text-neutral-400">Verifying access…</div>;

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 text-sm rounded transition-colors ${isActive ? "bg-neutral-900 text-white" : "text-neutral-500 hover:bg-neutral-100"}`;

  return (
    <div className="flex min-h-screen bg-neutral-50 font-sans text-neutral-900">
      <aside className="w-64 bg-white border-r border-neutral-200 flex flex-col fixed h-full">
        <div className="p-6 border-b border-neutral-200 flex items-center gap-2">
          <Gem size={18} /> <span className="font-serif text-lg">Maison Évaren</span>
        </div>
        <nav className="flex-1 overflow-y-auto p-3 space-y-1">
          <div className="px-4 py-2 text-[0.6rem] tracking-widest uppercase text-neutral-400">Central Admin</div>
          {central.map(([to, label, Icon, end]) => (
            <NavLink key={to} to={to} end={end} className={linkCls} data-testid={`admin-nav-${label.split(" ")[0].toLowerCase()}`}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
          <div className="px-4 py-2 mt-4 text-[0.6rem] tracking-widest uppercase text-neutral-400">Storefront Management</div>
          {storefront.map(([to, label, Icon]) => (
            <NavLink key={to} to={to} className={linkCls} data-testid={`admin-nav-${label.split(" ")[0].toLowerCase()}`}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-neutral-200">
          <button onClick={() => navigate("/")} className="w-full text-left px-4 py-2 text-sm text-neutral-500 hover:bg-neutral-100 rounded">View Storefront</button>
          <button data-testid="admin-logout" onClick={logout} className="w-full flex items-center gap-3 px-4 py-2 text-sm text-neutral-500 hover:bg-neutral-100 rounded"><LogOut size={16} /> Sign Out</button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8"><Outlet /></main>
    </div>
  );
}

export function SF_Picker({ value, onChange }) {
  return (
    <select data-testid="admin-storefront-picker" value={value} onChange={(e) => onChange(e.target.value)}
      className="h-10 px-3 border border-neutral-300 rounded text-sm bg-white">
      <option value="jewelry">Jewelry</option>
      <option value="men">Évaren Men</option>
      <option value="women">Évaren Women</option>
    </select>
  );
}
